import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { PersonSearchAutocompleteCustom } from "@/Common/Components/Search/PersonSearchAutocompleteCustom";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { Person } from "@/Common/Models/Person/Person";

import styles from "./OntarioCommonDataSetExportForm.module.scss";

interface IPatientsSelectionProps {
    selectedPatients: Person[];
    allChecked: boolean;
    onChange: (patients: Person[]) => void;
    onAllChecked: (isChecked: boolean) => void;
}

function PatientsSelection(props: Readonly<IPatientsSelectionProps>): JSX.Element {
    const { getText } = useTranslation();

    const updateSelection = (isSelected: boolean, patient: Person): void => {
        if (props.selectedPatients.any(p => p.ContactFacetId === patient.ContactFacetId) == isSelected) {
            return;
        }
        const nextSelection = isSelected ? [...props.selectedPatients, patient] : props.selectedPatients.filter(item => item.ContactFacetId !== patient.ContactFacetId);
        props.onChange(nextSelection);
    };

    const handleCheckAll = (isChecked: boolean): void => {
        if (isChecked) {
            props.onChange([]);
        }
        props.onAllChecked(isChecked);
    };

    return (
        <div className={styles.patients}>
            <span>{getText("PatientsLabel")}</span>
            <PersonSearchAutocompleteCustom
                useBlurEvent={true}
                componentId="cds_export_patients"
                selectedItemList={props.selectedPatients.length > 0 ? props.selectedPatients.toImmutable() : [].toImmutable()}
                onSelectionCallback={person => updateSelection(true, person.Item)}
                onClearCallback={person => updateSelection(false, person.Item)}
                focusOnLoad={false}
                closeDropDownAfterSelection={true}
                allowMultipleItemSelection={true}
                disabled={props.allChecked}
                dataCy="ontarioCommonDataSetExportForm_PatientSelect"
            />
            <CheckboxControl
                label={getText("AllPatientsLabel")}
                checked={props.allChecked}
                onChange={handleCheckAll}
                dataCy="ontarioCommonDataSetExportForm_AllPatientsCheckbox"
            />
        </div>
    );
}

export { PatientsSelection };
